export default __webpack_public_path__ + "a2bfd04afd1772d47b8c4d1203fd13c5.gif";